import React from "react";

function ArrowIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83329 1.3125C5.59167 1.3125 5.39579 1.50838 5.39579 1.75V2.1875H2.91663C2.675 2.1875 2.47913 2.38338 2.47913 2.625C2.47913 2.86662 2.675 3.0625 2.91663 3.0625H11.0833C11.3249 3.0625 11.5208 2.86662 11.5208 2.625C11.5208 2.38338 11.3249 2.1875 11.0833 2.1875H8.60413V1.75C8.60413 1.50838 8.40825 1.3125 8.16663 1.3125H5.83329Z"
        fill="#B9B7B3"
      />
      <path
        d="M5.83329 6.2125C6.07492 6.2125 6.27079 6.40837 6.27079 6.65L6.27079 10.7333C6.27079 10.975 6.07492 11.1708 5.83329 11.1708C5.59167 11.1708 5.39579 10.975 5.39579 10.7333L5.39579 6.65C5.39579 6.40837 5.59167 6.2125 5.83329 6.2125Z"
        fill="#B9B7B3"
      />
      <path
        d="M8.60413 6.65C8.60413 6.40837 8.40825 6.2125 8.16663 6.2125C7.925 6.2125 7.72913 6.40837 7.72913 6.65V10.7333C7.72913 10.975 7.925 11.1708 8.16663 11.1708C8.40825 11.1708 8.60413 10.975 8.60413 10.7333V6.65Z"
        fill="#B9B7B3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.49496 4.61835C3.51958 4.39679 3.70685 4.22917 3.92978 4.22917H10.0701C10.2931 4.22917 10.4803 4.39679 10.505 4.61835L10.6217 5.66914C10.8334 7.57391 10.8334 9.49627 10.6217 11.401L10.6102 11.5045C10.5262 12.2606 9.94022 12.8635 9.18683 12.9689C7.73599 13.1721 6.26393 13.1721 4.81309 12.9689C4.05969 12.8635 3.47371 12.2606 3.3897 11.5045L3.3782 11.401C3.16656 9.49627 3.16656 7.57391 3.3782 5.66914L3.49496 4.61835ZM4.32136 5.10417L4.24785 5.76576C4.04335 7.60632 4.04335 9.46386 4.24785 11.3044L4.25935 11.4079C4.29919 11.7664 4.5771 12.0524 4.93441 12.1024C6.30476 12.2942 7.69516 12.2942 9.06551 12.1024C9.42282 12.0524 9.70073 11.7664 9.74057 11.4079L9.75206 11.3044C9.95657 9.46386 9.95657 7.60632 9.75206 5.76577L9.67855 5.10417H4.32136Z"
        fill="#B9B7B3"
      />
    </svg>
  );
}

export default ArrowIcon;
